import { api } from "assets/scripts/utilities/api-clients";

export const cancel = async (params) => {
  const { purchaseBill, removeFiles } = params;
  const response = await api.put(`/purchase/bills/cancel`, {
    _id: purchaseBill._id,
    reason: purchaseBill.reason,
    isFilesToBeRemoved: removeFiles,
  });

  return response;
};

export const get = async (id) => {
  const response = await api.get(`/purchase/bill/${id}`);

  return response;
};

export const index = async (options = {}) => {
  const { source = "kam", ...rest } = options;
  const url = {
    kam: "/kam/bills",
    purchases: "/purchase/bills",
  };
  const response = await api.get(url[source], rest);

  return response;
};

export const post = async (
  purchaseBill,
  { params: { showMessage = false, ...restParams } = {}, ...restOptions } = {},
) => {
  const response = await api.post("/purchase/bills", purchaseBill, {
    params: { showMessage, ...restParams },
    ...restOptions,
  });

  return response;
};

export const put = async (
  purchaseBill,
  { params: { showMessage = false, ...restParams } = {}, ...restOptions } = {},
) => {
  const response = await api.put("/kam/bills", purchaseBill, {
    params: { showMessage, ...restParams },
    ...restOptions,
  });

  return response;
};

export const checkNumber = async (number) => {
  const response = await api.post("/kam/bill/number", number);

  return response;
};

export const getSummary = async () => {
  const response = await api.get("/purchase/bills/summary");

  return response;
};
